import {DRAWER_HEADER_HEIGHT_LG} from "~/components/main/drawer/DrawerConstants.ts";

/** The sticky tabs with their bottom spacing (33px + 16px). */
export const TABS_BAR_HEIGHT = 49;

/**
 * Everything that sticks to the top of the page: content scrolled into view lands just under it.
 * The title lives in the app's top bar, and the tabs are left out while they are hidden in this
 * version (`TABS_BAR_HEIGHT` with them), so nothing sticks for now.
 */
export const STICKY_HEADER_HEIGHT = 0;

/** The action bar stuck to the bottom of the page ("Send for approval"), its top border included. */
export const ACTION_BAR_HEIGHT = 64;

/**
 * Height of a tab's content: the window minus the top bar, the sticky tabs,
 * the page's bottom padding (16px, the gap above the action bar) and the action bar. Once the KPIs
 * have scrolled away, the tab's table or canvas fills the screen between the tabs and the action bar.
 */
export const TAB_CONTENT_HEIGHT = `calc(100vh - ${DRAWER_HEADER_HEIGHT_LG}px - ${STICKY_HEADER_HEIGHT}px - 16px - ${ACTION_BAR_HEIGHT}px - 2px)`;
